// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1b6019b1] .el-dialog {\n  max-width: 1000px;\n}\n[data-v-1b6019b1] .el-dialog__body {\n  margin-bottom: -20px;\n}\n.switch-wrapper[data-v-1b6019b1] {\n  display: flex;\n  align-items: center;\n}\n.switch-label[data-v-1b6019b1] {\n  padding-left: 15px;\n  line-height: 1.1;\n}", ""]);
// Exports
module.exports = exports;
